import React, { useEffect, useState }from 'react'
// 缺省头像
const defaultAvatar = 'https://cdn.shubox.com/images/ubox-default-avatar.png'

const ImageAvatar = (props: { avatarUrl: string, alt: string, className: string }) => {
  const [ avatarUrl, setAvatarUrl ] = useState(defaultAvatar)
  useEffect(() => {
    if(!props.avatarUrl) return
    const _pic = new Image()
    _pic.src = props.avatarUrl
    _pic.onload = () => {
      setAvatarUrl(props.avatarUrl)
    }
  }, [props.avatarUrl])
  return <>
    <img alt={props?.alt ?? 'avatar'}
        className={props?.className ?? ''}
        src={avatarUrl} />
  </>
}

export default ImageAvatar